export const formatNameAlias = async (
  nameForm: string,
  setAliasFormResult: React.Dispatch<React.SetStateAction<string>>
) => {
  let nameFormFormatted = nameForm
    .replace(/[ÁÀÃÂÄ]/g, "A")
    .replace(/[ÉÈÊË]/g, "E")
    .replace(/[ÍÌÎÏ]/g, "I")
    .replace(/[ÓÒÕÔÖ]/g, "O")
    .replace(/[ÚÙÛÜ]/g, "U")
    .replace(/[Ç]/g, "C")
    .replace(/[Ñ]/g, "N")
    .replace(/[áàãâä]/g, "a")
    .replace(/[éèêë]/g, "e")
    .replace(/[íìîï]/g, "i")
    .replace(/[óòõôö]/g, "o")
    .replace(/[úùûü]/g, "u")
    .replace(/[ç]/g, "c")
    .replace(/[ñ]/g, "n")
    .toLowerCase();
  nameFormFormatted = nameFormFormatted
    .replace(/[^\w\s]/gi, "")
    .replace(/\s+/g, "_");
  setAliasFormResult(nameFormFormatted);
};
